<template>
  <div>
    <van-popup v-model="show" closeable class="signup" @closed="resetFormData">
      <p class="title">S2BDIY供应链商学院报名</p>
      <div class="van-hairline--top"></div>
      <div class="van-hairline--surround fieldWrap" v-for="(value, index) in formTem" :key="index">
        <van-field
          v-model="formData[value.prop]"
          label-width="1.5rem"
          clearable
          :name="value.prop"
          :label="value.placeholder"
          :placeholder="value.placeholder"
        >
          <template slot="left-icon">
            <img :src="value.icon" alt="" class="slot" />
          </template>
        </van-field>
      </div>
      <div class="bottom">
        <van-button @click="submit">立即报名</van-button>
      </div>
    </van-popup>
    <van-notify v-model="showTip" class="reportError">
      <van-icon name="warning-o" style="margin-right:4px" />
      <span>{{ tip }}</span>
    </van-notify>
  </div>
</template>

<script>
import { getReport, postReport } from "@/api/signup"
export default {
  name: "SignUp",
  data() {
    return {
      showTip: false,
      tip: "",
      show: false,
      formData: {
        name: "",
        phone: "",
        wechat: "",
        job: ""
      },
      formTem: [
        { prop: "name", placeholder: "用户名", icon: require("@/assets/signUp/icons_user.png") },
        { prop: "phone", placeholder: "联系电话", icon: require("@/assets/signUp/icons_phone.png") },
        { prop: "wechat", placeholder: "联系微信", icon: require("@/assets/signUp/icons_wx.png") },
        { prop: "job", placeholder: "目前职业", icon: require("@/assets/signUp/icons_vocation.png") }
      ]
    }
  },
  methods: {
    resetFormData() {
      this.formData = {
        name: "",
        phone: "",
        wechat: "",
        job: ""
      }
    },
    submit() {
      const { formData } = this
      const props = Object.keys(formData)
      for (let i = 0; i < props.length; i++) {
        const prop = props[i]
        if (formData[prop] === "") {
          const tip = this.formTem.find(item => item.prop === prop).placeholder
          this.tip = tip + "必填"
          this.showTip = true
          setTimeout(() => {
            this.showTip = false
          }, 1000)
          return
        }
      }
      getReport().then(res => {
        if (res === null) {
          postReport(this.formData).then(() => {
            this.$emit("change")
          })
        } else {
          this.$notify({
            type: "warning",
            message: "已报名,请勿重复报名"
          })
          this.$router.push({
            name: "recharge",
            params: {
              rechargeTyep: 3
            }
          })
          this.show = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.signup {
  .van-hairline--top {
    width: 250px;
    margin: 0 auto;
  }
  .title {
    font-size: 18px;
    color: #10239e;
    font-weight: 600;
    width: 280px;
    padding-top: 20px;
    padding-bottom: 10px;
    text-align: center;
  }
  .fieldWrap {
    width: 240px;
    margin: 0 auto;
    margin-top: 20px;
    &:after {
      border-radius: 10px;
    }
    .slot {
      height: 16px;
      margin-top: 3.75px;
    }
  }
  .bottom {
    margin-top: 10px;
    padding-bottom: 40px;
    text-align: center;
  }
}
</style>
